<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller" />

    <!-- HEADER -->
    <div class="header bg-gradient-primary pb-8 pt-5 pt-md-8 hide">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <!-- COMPONENTE PRINCIPAL -->
          <div class="row">
            <div class="col-lg-3">
              <div class="card shadow">
                <div class="card-header">
                  <i class="ni ni-briefcase-24"></i> Departamentos
                </div>
                <div class="card-body p-0">
                  <div class="list-group">
                    <button class="btn btn-link btn-sm" @click="selectDpto()">
                      <i class="fa fa-plus-circle text-success"></i> Agregar nuevo
                    </button>
                    <!-- Element to collapse -->
                    <b-collapse id="newDep" v-model="isNewDep">
                      <div class="input-group">
                        <input
                          :disabled="loading"
                          @keyup.enter="saveDepartamento(true)"
                          type="text"
                          class="form-control"
                          placeholder="Nombre del departamento"
                          v-model="selectedDpto.caption"
                        />
                        <div class="input-group-append">
                          <button
                            class="btn btn-success"
                            type="button"
                            @click="saveDepartamento(true)"
                            :disabled="loading || selectedDpto.caption.trim().length < 1"
                          >
                            <i class="fa fa-plus-circle"></i>
                          </button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <div class="list-group small">
                    <template v-for="(dpto, dptoIndex) in departamentos">
                      <a
                        :key="'deptKey'+dptoIndex"
                        @click="selectDpto(dpto)"
                        href="javascript:void(0);"
                        :class="{ 'active': dpto.id == selectedDpto.id}"
                        class="list-group-item list-group-item-action border-0"
                      >
                        {{dpto.caption}}
                        <i class="fa fa-chevron-right float-right"></i>
                      </a>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card shadow" v-if="selectedDpto.id > 0">
                <div class="card-header">
                  <i class="fas fa-info-circle"></i> Detalles
                </div>
                <div class="card-body">
                  <div class="form-group">
                    <input
                      type="text"
                      name
                      id
                      class="form-control form-control-alternative"
                      v-model="selectedDpto.caption"
                    />
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-control-alternative custom-checkbox mb-3">
                      <input
                        class="custom-control-input"
                        id="customCheck5"
                        type="checkbox"
                        v-model="selectedDpto.activo"
                      />
                      <label class="custom-control-label" for="customCheck5">Activo</label>
                    </div>
                  </div>

                  <div class="form-group">
                    <button
                      class="btn btn-info btn-sm"
                      type="button"
                      @click="saveDepartamento(false)"
                    >Actualizar</button>
                    <button class="btn btn-secondary btn-sm" type="button" @click="getMenus">
                      <i class="fas fa-bars"></i> Ver Menus
                    </button>
                  </div>
                  <p class="text-muted small m-0">
                    Modificado por
                    <span class="text-info">{{selectedDpto.usuario_actualizacion}}</span>,
                    <br />
                    en {{selectedDpto.fecha_actualizacion | formatDate}}
                  </p>
                </div>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="card shadow" v-if="menus.length > 0 && !isNewDep">
                <div class="card-header">
                  <i class="fas fa-bars"></i> Menus
                </div>
                <div class="card-body p-0">
                  <ul class="list-group list-group-flush small">
                    <li
                      v-for="(menu, menuIndex) in menus"
                      :key="'menuKey'+menuIndex"
                      class="list-group-item border-0"
                    >
                      <span class>{{menu.caption}}</span>

                      <template v-if="menu !== null">
                        <button
                          v-if="!checkIfAssociated(menu)"
                          v-b-tooltip.hover
                          title="Agregar al departamento"
                          type="button"
                          class="btn btn-secondary btn-sm float-right"
                          @click="toggleAssociation(menu)"
                        >
                          <i class="far fa-square"></i>
                        </button>

                        <button
                          v-else
                          v-b-tooltip.hover
                          title="Remover del departamento"
                          variant="danger"
                          type="button"
                          class="btn btn-success btn-sm float-right"
                          @click="toggleAssociation(menu)"
                        >
                          <i class="fas fa-check"></i>
                        </button>
                      </template>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dataService from "@/services/departamentos.services.js";
import middleware from "@/helpers/middleware.js";
import sysMsg from "@/helpers/system.message.js";

import utils from "@/helpers/utils";
export default {
  name: "Departamentos",
  data() {
    return {
      loading: false,

      controller: {
        title: "Departamentos",
        mainRouter: "/tinformacion/departamentos"
      },
      departamentos: [],
      menus: [],
      selectedDpto: {
        id: 0,
        caption: "",
        fecha_actualizacion: "",
        usuario_actualizacion: "",
        activo: true
      }
    };
  },
  computed: {
    isNewDep: {
      get: function() {
        return this.selectedDpto.id == 0;
      },
      // setter
      set: function(newValue) {}
    }
  },
  created() {
    this.isNewDep = false;
    this.getDepartamentos(0);
  },
  filters: {
    formatDate(val) {
      return utils.formatDateTime(val);
    }
  },
  methods: {
    selectDpto(dpto) {
      if (typeof dpto == "undefined") {
        dpto = {
          id: 0,
          caption: "",
          fecha_actualizacion: new Date(),
          usuario_actualizacion: middleware.getUser().email,
          activo: true
        };
      }
      this.selectedDpto = dpto;
    },
    saveDepartamento(nvo) {
      if (this.selectedDpto.caption.trim().length < 1) {
        return false;
      }

      var $this = this;
      var dep = {
        id: this.selectedDpto.id,
        caption: this.selectedDpto.caption,
        url:
          this.selectedDpto.url != null && this.selectedDpto.url.length > 0
            ? this.selectedDpto.url
            : this.selectedDpto.caption.replace(/[^a-zA-Z0-9-_\.]/g, ""),
        icon: this.selectedDpto.icon == null ? "" : this.selectedDpto.icon,
        usuario: middleware.getUser().email,
        activo: this.selectedDpto.activo
      };
      console.log("dep", dep);

      sysMsg
        .getConfirm("¿Está seguro que desea guardar los cambios?", "question")
        .then(function(resp) {
          if (resp.value) {
            dataService.departamentos
              .set(dep)
              .then(function(resp) {
                dep = resp.data.departamentos[0];
                if (nvo) {
                  $this.$set($this.selectedDpto, "id", dep.id);
                  $this.departamentos.push(dep);
                }
                $obj.$set(
                  $obj.selectedDpto,
                  "usuario_actualizacion",
                  dep.usuario_actualizacion
                );
                $obj.$set(
                  $obj.selectedDpto,
                  "fecha_actualizacion",
                  dep.fecha_actualizacion
                );

                sysMsg.getMessage(
                  "Solicitud procesada exitosamente",
                  "success"
                );
              })
              .catch(function(e) {
                sysMsg.getResponseMessage(e.response);
              });
          }
        });
    },
    getMenus() {
      var $this = this;
      dataService.menus.getAll(0).then(function(resp) {
        $this.menus = resp.data.menus;
      });
    },
    toggleAssociation(menu) {
      var indexMenuDep = this.selectedDpto.menus.findIndex(function(m) {
        return m.id_menu == menu.id;
      });

      let record = {
        id_di: this.selectedDpto.id,
        id_me: menu.id,
        activo:
          indexMenuDep > -1 &&
          this.selectedDpto.menus[indexMenuDep].activo == true
            ? 0
            : 1,
        usuario: middleware.getUser().email
      };

      let menuDep = {
        caption_menu: menu.caption,
        id_menu: menu.id,
        activo: record.activo == 1 ? true : false
      };

      var $this = this;
      sysMsg
        .getConfirm("¿Está seguro que desea realizar esta acción?", "question")
        .then(function(resp) {
          if (resp.value) {
            dataService.departamentos
              .setMenu(record)
              .then(function(resp) {
                if (indexMenuDep > -1) {
                  $this.$set($this.selectedDpto.menus, indexMenuDep, menuDep);
                } else {
                  $this.selectedDpto.menus.push(menuDep);
                }
                sysMsg.getMessage(
                  "Solicitud procesada exitosamente",
                  "success"
                );
              })
              .catch(function(e) {
                sysMsg.getResponseMessage(e.response);
              });
          }
        });
    },
    checkIfAssociated(menu) {
      if (
        !this.selectedDpto.hasOwnProperty("menus") ||
        this.selectedDpto.menus == null ||
        typeof this.selectedDpto.menus == "undefined"
      ) {
        return false;
      }
      let menuDep = this.selectedDpto.menus.find(function(m) {
        return JSON.parse(m.activo) == true && m.id_menu == menu.id;
      });
      return typeof menuDep != "undefined";
    },
    getDepartamentos(id = 0) {
      var $this = this;
      dataService.departamentos.getAll(id).then(function(resp) {
        $this.departamentos = resp.data.departamentos;
      });
    }
  }
};
</script>